import { createAsyncTypes } from 'utils/ActionCreator'

const SCOPE = 'Settings/CreditsManagement'

export const GET_CREDITS_OVERVIEW_ASYNC = createAsyncTypes('GET_CREDITS_OVERVIEW', SCOPE)

export const SET_HISTORICAL_USAGE_FILTER = `${SCOPE}/SET_HISTORICAL_USAGE_FILTER`

export const SET_PEOPLE_PAGE = `${SCOPE}/SET_PEOPLE_PAGE`

export const SET_HISTORY_FILTER = `${SCOPE}/SET_HISTORY_FILTER`

export const SET_INVOICES_SORT = `${SCOPE}/SET_INVOICES_SORT`

export const GET_HISTORY_LOG_ASYNC = createAsyncTypes('GET_HISTORY_LOG', SCOPE)

export const GET_INVOICES_ASYNC = createAsyncTypes('GET_INVOICES', SCOPE)

export const GET_PRICING_ASYNC = createAsyncTypes('GET_PRICING', SCOPE)

export const GET_SETUP_INTENT_ASYNC = createAsyncTypes('GET_SETUP_INTENT', SCOPE)

export const GET_CHECKOUT_SESSION_ASYNC = createAsyncTypes('GET_CHECKOUT_SESSION', SCOPE)

export const CREATE_PORTAL_SESSION_ASYNC = createAsyncTypes('CREATE_PORTAL_SESSION', SCOPE)

export const UPDATE_MONTHLY_LIMIT_ASYNC = createAsyncTypes('UPDATE_MONTHLY_LIMIT', SCOPE)

export const CANCEL_SUBSCRIPTION_ASYNC = createAsyncTypes('CANCEL_SUBSCRIPTION', SCOPE)

export const UNSUBSCRIBE_COMPLETE_COPY = {
  title: 'Unsubscribe complete',
  body: 'Change your mind?',
  cta: 'Resubscribe',
}

export const UNSUBSCRIBE_COMPLETE_TOAST_ID = 'billing-unsubscribe-complete-toast'

export const UNSUBSCRIBE_COMPLETE_TOAST_MS = 5000

export const DEFAULT_HISTORY_PAGE_SIZE = 25

export const DEFAULT_PEOPLE_PAGE_SIZE = 10
